import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = ["id", "disabled", "onClick"];
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
import { SpriteIcons } from '@/user/components/common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LineTabs',
    props: {
        className: { default: undefined },
        color: { default: 'default' },
        hasButton: { type: Boolean, default: false },
        buttonIconName: { default: undefined },
        tabs: {}
    },
    emits: ["tabClick", "optionClick"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const input = tv({
            slots: {
                tabsCover: clsx('border-b-1 relative overflow-hidden border-gray-200', '', 'desktop:min-w-1400'),
                tabsInner: clsx('py-18 mx-auto flex overflow-y-auto px-16', 'gap-40', 'desktop:gap-44 desktop:px-0 desktop:max-w-1280 desktop:mx-auto'),
                tabItem: clsx('text-m-title-2 flex items-center whitespace-nowrap text-gray-600 disabled:text-gray-300', 'desktop:text-body-3'),
                tabCountStyle: clsx('', 'ml-4', 'desktop:ml-6'),
                optionButton: clsx('desktop:hidden absolute right-0 top-1/2 -translate-y-1/2 transform bg-white p-16'),
                optionButtonGradient: clsx('-z-1 absolute inset-0 -left-16 h-full w-16 bg-gradient-to-r from-transparent to-white'),
            },
            variants: {
                color: {
                    default: {
                        tabItem: 'hover:text-blue-700',
                    },
                    teal: {
                        tabItem: 'hover:text-teal-700',
                    },
                    violet: {
                        tabItem: 'hover:text-violet-700',
                    },
                    mutedBlue: {
                        tabItem: 'hover:text-muted-blue-700',
                    },
                    dark: {
                        tabItem: 'hover:text-blue-600 disabled:text-gray-800',
                    },
                },
                isActive: {
                    true: '',
                    false: '',
                },
            },
            compoundVariants: [
                {
                    color: 'default',
                    isActive: true,
                    class: {
                        tabItem: 'text-blue-700',
                    },
                },
                {
                    color: 'teal',
                    isActive: true,
                    class: {
                        tabItem: 'text-teal-700',
                    },
                },
                {
                    color: 'violet',
                    isActive: true,
                    class: {
                        tabItem: 'text-violet-700',
                    },
                },
                {
                    color: 'mutedBlue',
                    isActive: true,
                    class: {
                        tabItem: 'text-muted-blue-700',
                    },
                },
                {
                    color: 'dark',
                    isActive: true,
                    class: {
                        tabItem: 'text-blue-600',
                    },
                },
            ],
            defaultVariants: {
                color: 'default',
                isActive: false,
                class: {
                    tabItem: 'text-gray-600',
                },
            },
        });
        const { tabsCover, tabsInner, tabItem, tabCountStyle, optionButton, optionButtonGradient } = input();
        const handleTabClick = (tab) => {
            if (!tab.disabled) {
                emit('tabClick', tab);
            }
        };
        const handleOptionClick = () => {
            emit('optionClick');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_unref(clsx)(_unref(tabsCover)(), props.className))
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(_unref(clsx)(_unref(tabsInner)(), {
                        'pr-72': props.hasButton,
                    }))
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (tab) => {
                        return (_openBlock(), _createElementBlock("button", {
                            id: tab.id,
                            key: tab.id,
                            class: _normalizeClass(_unref(clsx)(_unref(tabItem)({
                                color: __props.color,
                                isActive: tab.isActive,
                            }))),
                            disabled: tab.disabled,
                            type: "button",
                            onClick: ($event) => (handleTabClick(tab))
                        }, [
                            _createTextVNode(_toDisplayString(tab.text) + " ", 1),
                            (tab.tabCount)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(_unref(clsx)(_unref(tabCountStyle)()))
                                }, _toDisplayString(tab.tabCount), 3))
                                : _createCommentVNode("", true)
                        ], 10, _hoisted_1));
                    }), 128))
                ], 2),
                (props.hasButton)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(_unref(clsx)(_unref(optionButton)())),
                        type: "button",
                        onClick: handleOptionClick
                    }, [
                        _createElementVNode("span", {
                            class: _normalizeClass(_unref(clsx)(_unref(optionButtonGradient)()))
                        }, null, 2),
                        _createVNode(_unref(SpriteIcons), {
                            class: "h-24 w-24",
                            name: props.buttonIconName
                        }, null, 8, ["name"])
                    ], 2))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
